<template>
  <header
    class="default"
    :class="{
      'header-visible': showHeader,
      'header-mobile-sticky': isMobile
    }"
  >
    <nav class="navbar navbar-default bootsnav on no-full">
      <div class="container">
        <div
          v-if="isMobile && !menuOpen"
          class="menu-icon"
          role="button"
          tabindex="0"
          aria-label="Menü öffnen"
          @click="$emit('toggle-menu')"
          @keydown.enter.prevent="$emit('toggle-menu')"
          @keydown.space.prevent="$emit('toggle-menu')"
        >
          <span></span>
        </div>
        <div class="navbar-header">
          <a class="navbar-brand" href="/">
            <img src="/images/hbg_logo.png" class="logo" alt="" />
          </a>
        </div>
        <div class="collapse navbar-collapse" id="navbar-menu">
          <ul
            class="nav navbar-nav navbar-right"
            data-in="fadeInDown"
            data-out="fadeOutUp"
          >
            <li
              :key="nav"
              v-for="(nav, index) in navigation"
              :class="index === 0 ? 'active' : ''"
            >
              <a :href="'#' + nav.key" class="scroll"> {{ nav.label }}</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

const MOBILE_MAX_WIDTH = 767

export default {
  props: {
    navigation: Array,
    menuOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-menu'],
  setup() {
    const showHeader = ref(true)
    const isMobile = ref(false)
    let mediaQuery = null

    const updateHeaderVisibility = () => {
      if (typeof window === 'undefined') return

      isMobile.value = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches
      if (!isMobile.value) {
        showHeader.value = true
        return
      }

      // Mobile: Header bleibt immer sticky sichtbar
      showHeader.value = true
    }

    onMounted(() => {
      updateHeaderVisibility()

      mediaQuery = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`)
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', updateHeaderVisibility)
      } else {
        mediaQuery.addListener(updateHeaderVisibility)
      }
    })

    onUnmounted(() => {
      if (!mediaQuery) return
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', updateHeaderVisibility)
      } else {
        mediaQuery.removeListener(updateHeaderVisibility)
      }
    })

    return {
      showHeader,
      isMobile
    }
  }
}
</script>
